// ScheduleStep.tsx
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

import { TrainingInput } from "./types";

interface ScheduleStepProps {
  newTraining: Partial<TrainingInput>;
  setNewTraining: (training: Partial<TrainingInput>) => void;
}

const ScheduleStep: React.FC<ScheduleStepProps> = ({ newTraining, setNewTraining }) => {
  const [currentRequirement, setCurrentRequirement] = useState("");

  const addRequirement = () => {
    if (currentRequirement.trim()) {
      setNewTraining({
        ...newTraining,
        requirements: [...(newTraining.requirements || []), currentRequirement.trim()],
      });
      setCurrentRequirement("");
    }
  };

  const removeRequirement = (index: number) => {
    setNewTraining({
      ...newTraining,
      requirements: (newTraining.requirements || []).filter((_, i) => i !== index),
    });
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="space-y-2">
        <Label htmlFor="startDate">Start Date *</Label>
        <Input
          id="startDate"
          type="date"
          value={newTraining.startDate || ""}
          onChange={(e) => setNewTraining({ ...newTraining, startDate: e.target.value })}
          required
        />
      </div>
      <div className="space-y-2">
        <Label>Requirements</Label>
        <div className="flex gap-2">
          <Input
            value={currentRequirement}
            onChange={(e) => setCurrentRequirement(e.target.value)}
            placeholder="e.g., Basic HTML knowledge"
          />
          <Button type="button" onClick={addRequirement}>
            Add
          </Button>
        </div>
        <ul className="mt-2 space-y-1">
          {newTraining.requirements?.map((req, index) => (
            <li key={index} className="flex justify-between items-center">
              <span>{req}</span>
              <Button variant="ghost" size="sm" onClick={() => removeRequirement(index)}>
                Remove
              </Button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ScheduleStep;